import { ArchitecturePlayground } from "./ArchitecturePlayground";
import { SystemMap } from "./SystemMap";

/**
 * "어떻게 만들었나" - structure only, since the five-act narrative moved to its own
 * "만든 이야기" tab (user-directed, 2026-08-15). Order: the IT-view architecture and
 * the role map (SystemMap), then the playable request-flow map. The closing line hands
 * the reader over to the story tab so the "why" is one click away, not lost.
 */

interface Props {
  onVerify?: () => void;
}

export function Overview({ onVerify }: Props) {
  return (
    <>
      <p className="muted">
        이 탭은 <strong>시스템의 구조</strong>를 보여줍니다 — 전체 아키텍처, 세 층의 역할,
        그리고 송금 한 건이 지나가는 길의 재생. <strong>왜 이렇게 만들었는지</strong>는
        &quot;만든 이야기&quot; 탭에 5막으로 정리되어 있어요.
      </p>

      <SystemMap />

      <ArchitecturePlayground onVerify={onVerify} />
    </>
  );
}
